module.exports = __webpack_public_path__ + "img/timg.54ab968d.gif";